import type { CogniteFunctionDefinition } from '#core/hooks/fusion/useCogniteFunction';
import { z } from 'zod';

export const HydroblendRequest = z.object({
  model_key: z.enum(['hydroblend']).default('hydroblend').describe('The key of the model to be used for prediction'),
  ml_inputs: z.object({
    sg: z
      .number()
      .min(1, { error: 'SG must be in range 1.0~1.2' })
      .max(2, { error: 'SG must be in range 1.0~1.2' })
      .describe('Specific Gravity (SG) value'),
    reservoir: z
      .string({ error: 'Reservoir must be specified' })
      .describe('Reservoir name, must be equal to the `name` of a reservoir in the `Reservoir` view.'),
  }),
});

export type HydroblendRequest = z.input<typeof HydroblendRequest>;

export const HydroblendResponse = z.object({
  model: z.enum(['hydroblend']).describe('The key of the model used for prediction'),
  predictions: z.object({
    predicted_value: z.number().describe('The predicted seawater percentage (SW%) value'),
    units: z.enum(['seawater_percentage']).describe('The units of the predicted value'),
  }),
});

export type HydroblendResponse = z.input<typeof HydroblendResponse>;

export const HydroblendFunction = {
  externalId: 'fn_scale_poc_ml_predict_uc1',
  request: HydroblendRequest,
  response: HydroblendResponse,
} as const satisfies CogniteFunctionDefinition;

export type HydroblendFunction = typeof HydroblendFunction;
